import { useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, IMAGES, openPaymentModal } from "@/data/content";

const Nav = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="main-nav"
      className="sticky top-0 z-50 bg-white border-b border-slate-200/70 shadow-sm"
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-8 flex items-center justify-between gap-2 h-16 lg:h-20">
        <a href="#top" data-testid="nav-logo" className="flex items-center py-2">
          <img
            src={IMAGES.logo}
            alt="IQMIZE — Maximize Your Mind"
            className="h-10 lg:h-16 w-auto max-w-[120px] sm:max-w-[200px] lg:max-w-[240px] object-contain object-left"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8" data-testid="nav-links">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-semibold text-slate-600 hover:text-brand transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#look-inside"
            data-testid="nav-preview-book-btn"
            className="gold-pulse inline-flex items-center whitespace-nowrap rounded-full border-2 border-igold bg-igold/10 px-3 py-2 text-xs font-bold text-slate-800 transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-igold/20 sm:px-5 sm:py-2.5 sm:text-sm"
          >
            Preview Book
          </a>
          <button
            type="button"
            data-testid="nav-get-book-btn"
            onClick={() => openPaymentModal("nav")}
            className="inline-flex items-center whitespace-nowrap rounded-full bg-brand px-3 py-2 text-xs font-bold text-white shadow-md transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-0.5 hover:bg-brand-dark hover:shadow-lg sm:px-5 sm:py-2.5 sm:text-sm"
          >
            <span className="sm:hidden">Book ₹49</span>
            <span className="hidden sm:inline">Get the Book — ₹49</span>
          </button>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-slate-700"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-200 shadow-lg" data-testid="nav-mobile-menu">
          <div className="px-5 py-4 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="py-3 px-2 text-sm font-semibold text-slate-700 hover:text-brand border-b border-slate-100 last:border-0"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#look-inside"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-preview-book-btn"
              className="py-3 px-2 text-sm font-semibold text-slate-700 hover:text-brand border-b border-slate-100"
            >
              Preview Book
            </a>
            <button
              type="button"
              data-testid="nav-mobile-get-book-btn"
              onClick={() => { setOpen(false); openPaymentModal("nav-mobile"); }}
              className="mt-3 rounded-full bg-brand px-6 py-3 text-sm font-bold text-white"
            >
              Get the Book — ₹49
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
